import { ParamMap, Params } from '@angular/router';
import { UserStatus } from 'src/app/models/enums';
import {
  parseEnumList,
  parseNumberList,
  serializeNumberList,
  serializeStringList,
} from './filterUtils';

export interface IUsersFilters {
  selectedClients: number[];
  selectedTowns: number[];
  selectedOperators: number[];
  selectedStatus: UserStatus[];
}

export const USER_FILTER_KEYS = [
  'clients', 'towns', 'operators', 'status'
] as const;

export function serializeUsersFilters(f: IUsersFilters): Params {
  return {
    clients: serializeNumberList(f.selectedClients),
    towns: serializeNumberList(f.selectedTowns),
    operators: serializeNumberList(f.selectedOperators),
    status: serializeStringList(f.selectedStatus),
  };
}

export function deserializeUsersFilters(params: ParamMap): IUsersFilters {
  return {
    selectedClients: parseNumberList(params.get('clients')),
    selectedTowns: parseNumberList(params.get('towns')),
    selectedOperators: parseNumberList(params.get('operators')),
    selectedStatus: parseEnumList<UserStatus>(params.get('status')),
  };
}

export function parseUsersFiltersFromStorage(json: string | null | undefined): IUsersFilters | null {
  if (!json) return null;
  try {
    const f = JSON.parse(json);
    return {
      selectedClients: Array.isArray(f.selectedClients) ? f.selectedClients : [],
      selectedTowns: Array.isArray(f.selectedTowns) ? f.selectedTowns : [],
      selectedOperators: Array.isArray(f.selectedOperators) ? f.selectedOperators : [],
      selectedStatus: Array.isArray(f.selectedStatus) ? f.selectedStatus : [],
    };
  } catch {
    return null;
  }
}
